import React from 'react';
import { Icon } from '../Icon/Icon';
import { AR_INSURER_LIST, AR_NUMBERS } from '../../ar/mockData';

export interface ArInsurerDrawerProps {
  open: boolean;
  onClose?: () => void;
}

/**
 * See who — the read-only drawer behind the insurer row (§2.1). The balances the
 * insurer is still deciding, with claim status. **Not** the payment-links tab:
 * ELVA never asks these patients.
 */
export function ArInsurerDrawer({ open, onClose }: ArInsurerDrawerProps) {
  if (!open) return null;
  return (
    <>
      <button type="button" aria-label="Close" className="fixed inset-0 z-40 bg-[rgba(17,20,28,0.32)]" onClick={onClose} />
      <aside className="fixed right-0 top-0 z-50 flex h-full w-[460px] max-w-[92vw] flex-col bg-[var(--surface-card)] shadow-[var(--shadow-modal)]">
        <div className="flex items-start justify-between gap-3 border-b border-[var(--border-default)] px-5 py-4">
          <div>
            <div className="pc-eyebrow text-[var(--text-muted)]">With the insurer</div>
            <div className="mt-0.5 text-[16px] font-bold text-[var(--text-primary)]">
              {AR_NUMBERS.withInsurerPatients} patients · {AR_NUMBERS.withInsurer}
            </div>
            <p className="m-0 mt-1 text-[12px] leading-[1.5] text-[var(--text-muted)]">
              An open claim or a denial that can be appealed. ELVA doesn’t ask these patients — a person works the claim.
            </p>
          </div>
          <button type="button" onClick={onClose} className="shrink-0 rounded-[var(--r-md)] p-1 text-[var(--text-muted)] hover:bg-[var(--surface-sunken)]">
            <Icon kind="x" size={16} stroke={2} />
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-3">
          {AR_INSURER_LIST.map((p) => (
            <div key={p.id} className="flex items-center justify-between gap-3 border-b border-[var(--border-default)] py-2.5 last:border-0">
              <div className="min-w-0">
                <div className="truncate text-[13px] font-semibold text-[var(--text-primary)]">{p.name}</div>
                <div className="truncate text-[11.5px] text-[var(--text-muted)]">{p.claim}</div>
              </div>
              <span className="shrink-0 font-[var(--font-mono)] text-[12.5px] font-bold text-[var(--text-secondary)]">{p.balance}</span>
            </div>
          ))}
          <p className="m-0 mt-3 text-[11.5px] text-[var(--text-muted)]">
            Showing {AR_INSURER_LIST.length} of {AR_NUMBERS.withInsurerPatients}.
          </p>
        </div>
      </aside>
    </>
  );
}
